const optimizelyLocales = process.env.OPTIMIZELY_LOCALES_URL_SEGMENTS
  ? process.env.OPTIMIZELY_LOCALES_URL_SEGMENTS?.split(',')
  : [];

// Since zh-cht and zh-cn is not valid locales we also need to include valid locales for date formatting
export const locales = [...optimizelyLocales, 'zh-hans', 'zh-hant'];

export const DEFAULT_LOCALE = 'en';
